import BoardTool from '@/components/common/ed-board/ed-board-tools/board-tool.interface';
import WboDrawerTools from '@/components/common/ed-board/ed-board-tools/ed-wbo-drawer/wbo-drawer-tools';

export default class EdWboDrawerEraserAll {

    private wboDrawerTools: WboDrawerTools;

    private erase: Function = () => {
        // this.Toolso.sendRemoveAllByUser();
        const currentUsername = this.wboDrawerTools.username;
        const isHost = this.wboDrawerTools.isHostUser;
        
        const annotationsToDelete = this.wboDrawerTools.annotations
            .filter(annotation => isHost ? true : this.wboDrawerTools.annotationOwners[annotation]?.userName == currentUsername);
        
        this.removeClientElements(annotationsToDelete);
        this.wboDrawerTools.drawAndSend({ tool: this.eraserAllTool.name }, this.eraserAllTool);
    }

    public removeClientElements: Function = (elementsToDelete: string[]) => {
        if (!elementsToDelete) {
            return;
        }

        elementsToDelete.forEach(elementId => {
            let elem = this.wboDrawerTools.svg.getElementById(elementId);
            if (elem) {
                this.wboDrawerTools.drawingArea.removeChild(elem);
            }
        });

    }


    private eraserAllTool: BoardTool = { //The new tool
        name       : 'Eraser All',
        listeners  : {},
        oneTouch   : true,
        onstart    : this.erase,
        draw       : (data: any) => {
            return true;
        },
        icon       : '/assets/tools/eraserAll/icon.svg',
        mouseCursor: 'crosshair',
        showMarker : true
    }

    constructor(tools: WboDrawerTools) {
        this.wboDrawerTools = tools;
        this.wboDrawerTools.add(this.eraserAllTool);
    }

}
